import api from './api';
import { Event, EventCategory, EventStatus, PaginatedResponse } from '../types';

interface EventFilters {
  status?: EventStatus;
  category?: EventCategory;
  search?: string;
  templeId?: number;
  page?: number;
  limit?: number;
}

export const eventService = {
  async getList(filters: EventFilters = {}): Promise<PaginatedResponse<Event>> {
    const params = new URLSearchParams();
    
    if (filters.status) params.append('status', filters.status);
    if (filters.category) params.append('category', filters.category);
    if (filters.search) params.append('search', filters.search);
    if (filters.templeId) params.append('templeId', filters.templeId.toString());
    if (filters.page) params.append('page', filters.page.toString());
    if (filters.limit) params.append('limit', filters.limit.toString());
    
    const response = await api.get<PaginatedResponse<Event>>('/events', { params });
    return response.data;
  },

  async getById(id: number): Promise<Event> {
    const response = await api.get<Event>(`/events/${id}`);
    return response.data;
  },

  async getBySlug(slug: string): Promise<Event> {
    const response = await api.get<Event>(`/events/${slug}`);
    return response.data;
  },

  async create(data: Omit<Event, 'id' | 'createdAt' | 'updatedAt'>): Promise<Event> {
    const response = await api.post<Event>('/events', data);
    return response.data;
  },

  async update(id: number, data: Partial<Event>): Promise<Event> {
    const response = await api.put<Event>(`/events/${id}`, data);
    return response.data;
  },

  async delete(id: number): Promise<void> {
    await api.delete(`/events/${id}`);
  },

  async publish(id: number): Promise<Event> {
    const response = await api.post<Event>(`/events/${id}/publish`);
    return response.data;
  },

  async unpublish(id: number): Promise<Event> {
    const response = await api.post<Event>(`/events/${id}/unpublish`);
    return response.data;
  },

  async duplicate(id: number): Promise<Event> {
    const response = await api.post<Event>(`/events/${id}/duplicate`);
    return response.data;
  },
};
